import React from 'react';
import CidadePage from './CidadePage';
import cidadeBH from '../data/cidades/belo-horizonte.json';

const BeloHorizontePage = () => <CidadePage cidade={cidadeBH} />;

export default BeloHorizontePage;
